import React from 'react';
import PropTypes from 'prop-types';

/**
 * Representation of a footer in the Dialog.
 * @param {object} props props
 * @param {React.ReactChildren} children react children elements
 * @returns {React.ReactElement} ModalNav
 */
export default function ModalNav({ children }) {
  return <div className='modal-nav'>{children}</div>;
}

ModalNav.propTypes = {
  /** Child elements */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};
